import { BlocState } from 'src/app/shared/bloc/base-bloc';

export class StatisticsChartState extends BlocState {}

export class StatisticsChartReadyStateState extends StatisticsChartState {
  constructor(public maleDataSets: number[] , public femalesDataSet : number[] , public labels : string[]) {
    super();
  }
}
